import React from 'react';
import GraphqlTable from 'cccisd-graphql-table';
import { assessmentPlans, instructors, learners, responseFlags, supervisors } from '../renders';
import PageHeader from '../../../components/PageHeader';
import sitesQuery from './sites.graphql';
import style from '../style.css';

const now = new Date();

const GUAdminDash = () => {
    const renders = {
        learners: t => {
            const learnerList = t.row['childRoles.learnerList'];
            const schoolLabel = t.row['group.label'];
            return learners({
                learnerList,
                context: schoolLabel,
                adjustColumns: c => c.filter(col => !['Student Name', 'School'].includes(col.label)),
            });
        },
        learnersActivePlans: t => {
            const learnerList = t.row['childRoles.learnerList'];
            const schoolLabel = t.row['group.label'];
            const learnersInActivePlans = learnerList.filter(learner => {
                return learner.selectedAssignmentPlanList.some(plan => plan?.openSessions?.length > 0);
            });
            return learners({
                learnerList: learnersInActivePlans,
                context: schoolLabel,
                adjustColumns: c => c.filter(col => !['Student Name', 'School'].includes(col.label)),
            });
        },
        instructors: t => {
            const instructorList = t.row['ancestorGroups.groupingUnit.descendantRoles.instructorList'];
            const schoolLabel = t.row['group.label'];
            return instructors({ instructorList, context: schoolLabel });
        },
        supervisors: t => {
            const supervisorList = t.row['ancestorGroups.groupingUnit.descendantRoles.supervisorList'];
            const schoolLabel = t.row['group.label'];
            return supervisors({ supervisorList, context: schoolLabel });
        },
        totalAssessmentPlans: t => {
            const instructorList = t.row['ancestorGroups.groupingUnit.descendantRoles.instructorList'];
            const schoolLabel = t.row['group.label'];
            const plans = [];
            instructorList.forEach(instructor => {
                if (instructor.createdAssignmentPlanCount > 0) {
                    instructor.createdAssignmentPlanList.forEach(plan => {
                        plans.push(plan);
                    });
                }
            });
            return assessmentPlans({
                planList: plans,
                context: schoolLabel,
                adjustColumns: c => {
                    return c.filter(col => col.label !== 'Actions');
                },
            });
        },
        activeAssessmentPlans: t => {
            const instructorList = t.row['ancestorGroups.groupingUnit.descendantRoles.instructorList'];
            const schoolLabel = t.row['group.label'];
            const plans = [];
            instructorList.forEach(instructor => {
                if (instructor.createdAssignmentPlanCount > 0) {
                    instructor.createdAssignmentPlanList.forEach(plan => {
                        if (plan.openSessions.length > 0) {
                            plans.push(plan);
                        }
                    });
                }
            });
            return assessmentPlans({
                planList: plans,
                context: schoolLabel,
                adjustColumns: c => {
                    return c.filter(col => col.label !== 'Actions');
                },
            });
        },
        responseFlags: t => {
            const learnerList = t.row['childRoles.learnerList'];
            const schoolLabel = t.row['group.label'];
            return responseFlags({ row: t.row, learnerList, context: schoolLabel });
        },
    };

    return (
        <>
            <div className="container">
                <PageHeader
                    title="Admin Dashboard"
                    description="View assessment plan activity from every provider in your group"
                />
                <div style={{ background: '#fff', textAlign: 'center' }} className={style.dashboardWrapper}>
                    <GraphqlTable
                        query={sitesQuery}
                        graphqlVariables={{ today: now.toJSON() }}
                        rowKey="group.groupId"
                        renders={renders}
                        columns={[
                            { name: 'group.label', label: 'School', filter: true, sort: true },
                            {
                                name: 'childRoles.learnerCount',
                                label: 'Total Students',
                                sort: true,
                                render: 'learners',
                                // hideInTable: true,
                            },
                            {
                                name: 'childRoles.learnerList',
                                label: 'Students with Plans',
                                tooltip: 'Number of students with at least one active plan',
                                render: 'learnersActivePlans',
                            },
                            {
                                name: 'totalAssessmentPlanCount',
                                label: 'Total Assessment Plans',
                                tooltip: 'Number of Assessment Plans that have ever been created',
                                render: 'totalAssessmentPlans',
                            },
                            {
                                name: 'activeAssessmentPlanCount',
                                label: 'Active Assessment Plans',
                                tooltip: 'Number of Assessment Plans that are currently open',
                                render: 'activeAssessmentPlans',
                            },
                            {
                                name: 'descendantRoles.instructorCount',
                                label: 'Providers',
                                render: 'instructors',
                                sort: true,
                            },
                            {
                                name: 'descendantRoles.supervisorCount',
                                label: 'Supervisors',
                                render: 'supervisors',
                                sort: true,
                            },
                            {
                                name: 'flagCount',
                                label: 'Response Flags',
                                sort: true,
                                render: 'responseFlags',
                            },
                        ]}
                        csvFilename="schools"
                    />
                </div>
            </div>
        </>
    );
};

export default GUAdminDash;
